// Mock data for Nistala's Group website

export const ecosystemVerticals = [
  {
    id: 'organic-hues',
    title: 'Organic Hues',
    tagline: 'Traditional Food, Modern Health',
    description: 'Farm-to-fork organic meals, oils, snacks, and powders rooted in Indian traditions',
    icon: 'Leaf',
    image: 'https://images.unsplash.com/photo-1728910156510-77488f19b152?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjB0cmFkaXRpb25hbCUyMGZvb2R8ZW58MHx8fHwxNzczODI4OTE3fDA&ixlib=rb-4.1.0&q=85',
    color: '#6B8E4E'
  },
  {
    id: 'green-horizon',
    title: 'Green Horizon',
    tagline: 'Future of Sustainable Farming',
    description: 'AgriTech consulting with agrivoltaics, AWG technology, and carbon credits',
    icon: 'Sprout',
    image: 'https://images.unsplash.com/photo-1761839257144-297ce252742e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxhZ3JpdGVjaCUyMG1vZGVybiUyMGZhcm1pbmd8ZW58MHx8fHwxNzczODI4OTM5fDA&ixlib=rb-4.1.0&q=85',
    color: '#6B8E4E'
  },
  {
    id: 'ecoroute',
    title: 'EcoRoute',
    tagline: 'Smart Logistics, Zero Waste',
    description: 'AI-optimized cold chain logistics connecting farmers to markets efficiently',
    icon: 'Truck',
    image: 'https://images.unsplash.com/photo-1761574319274-8a3a9cd80a6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsb2dpc3RpY3MlMjBkZWxpdmVyeXxlbnwwfHx8fDE3NzM4Mjg5NDN8MA&ixlib=rb-4.1.0&q=85',
    color: '#D4A574'
  },
  {
    id: 'wheros',
    title: 'WHeros',
    tagline: 'Empowering Women, Building Futures',
    description: 'Skill development hubs, community kitchens, and training programs for women',
    icon: 'Users',
    image: 'https://images.unsplash.com/photo-1646066490017-c935b1a1eb0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHx3b21lbiUyMGVtcG93ZXJtZW50JTIwdHJhaW5pbmd8ZW58MHx8fHwxNzczODI4OTQ2fDA&ixlib=rb-4.1.0&q=85',
    color: '#D4A574'
  },
  {
    id: 'rise-and-rolls',
    title: 'Rise & Rolls',
    tagline: 'Culinary Excellence, Cultural Pride',
    description: 'Culinary academy offering courses, masterclasses, and chef incubation programs',
    icon: 'ChefHat',
    image: 'https://images.unsplash.com/photo-1771257807642-9d256793ec6b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHxjdWxpbmFyeSUyMGVkdWNhdGlvbiUyMGNvb2tpbmd8ZW58MHx8fHwxNzczODI4OTUxfDA&ixlib=rb-4.1.0&q=85',
    color: '#6B8E4E'
  }
];

export const whyNistalas = [
  { icon: 'Users', value: '500+', label: 'Farmers Empowered' },
  { icon: 'Sparkles', value: 'Women-Led', label: 'AI-Driven Innovation' },
  { icon: 'Award', value: 'Global', label: 'UConn, WeHub Recognition' },
  { icon: 'Recycle', value: 'Zero-Waste', label: 'Sustainable Ecosystem' },
  { icon: 'Store', value: 'Franchise', label: 'Ready for Scale' }
];

export const testimonials = [
  {
    id: 1,
    name: 'Lakshmi Devi',
    role: 'Farmer Partner, Telangana',
    image: 'https://images.unsplash.com/photo-1622632405663-f43782a098b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHw0fHxJbmRpYW4lMjB3b21hbiUyMHNtaWxpbmclMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzQ1OTg5MDl8MA&ixlib=rb-4.1.0&q=85',
    content: 'Working with Nistala\'s has transformed my farming income. The training and support from WHeros has given me new skills and confidence.',
    rating: 5
  },
  {
    id: 2,
    name: 'Dr. Priya Sharma',
    role: 'Nutrition Consultant, Hyderabad',
    image: 'https://images.unsplash.com/photo-1590905775253-a4f0f3c426ff?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Njl8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjB3b21hbiUyMHNtaWxpbmclMjBwb3J0cmFpdCUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzQ1OTg5MDl8MA&ixlib=rb-4.1.0&q=85',
    content: 'The approach to personalized nutrition is revolutionary. The combination of traditional Indian wisdom with modern science is remarkable.',
    rating: 5
  },
  {
    id: 3,
    name: 'Rajesh Kumar',
    role: 'Restaurant Owner, Bangalore',
    image: 'https://images.unsplash.com/photo-1723085582062-78a8d6513e36?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjBtYW4lMjBzbWlsaW5nJTIwcG9ydHJhaXQlMjBwcm9mZXNzaW9uYWx8ZW58MHx8fHwxNzc0NTk4OTEwfDA&ixlib=rb-4.1.0&q=85',
    content: 'Organic Hues supplies the best quality organic ingredients. Their cloud kitchen model is efficient and the food quality is consistently excellent.',
    rating: 5
  }
];

export const partners = [
  { name: 'U.S. Consulate', logo: 'https://via.placeholder.com/120x60?text=US+Consulate' },
  { name: 'UConn', logo: 'https://via.placeholder.com/120x60?text=UConn' },
  { name: 'WeHub', logo: 'https://via.placeholder.com/120x60?text=WeHub' },
  { name: 'Akshayapatra', logo: 'https://via.placeholder.com/120x60?text=Akshayapatra' },
  { name: 'BigBasket', logo: 'https://via.placeholder.com/120x60?text=BigBasket' },
  { name: 'Startup India', logo: 'https://via.placeholder.com/120x60?text=Startup+India' }
];

export const knowledgeHub = [
  {
    id: 1,
    type: 'blog',
    title: 'The Science Behind Traditional Indian Superfoods',
    excerpt: 'Discover why turmeric, ghee, and millets are making a comeback in modern nutrition science.',
    image: 'https://images.unsplash.com/photo-1716816211590-c15a328a5ff0',
    date: '2025-07-10',
    category: 'Food 101'
  },
  {
    id: 2,
    type: 'podcast',
    title: 'Women in Agriculture: Breaking Barriers',
    excerpt: 'Hear inspiring stories from women farmers who are transforming Indian agriculture.',
    image: 'https://images.unsplash.com/photo-1707721691170-bf913a7a6231',
    date: '2025-07-08',
    category: 'WHeros Stories'
  },
  {
    id: 3,
    type: 'article',
    title: 'AI in Farming: The Future is Now',
    excerpt: 'How artificial intelligence is revolutionizing crop yield prediction and sustainable farming practices.',
    image: 'https://images.unsplash.com/photo-1656497119922-068c6a5e1193',
    date: '2025-07-05',
    category: 'AgriTech'
  }
];

export const productCategories = [
  {
    id: 'fresh-produce',
    name: 'Fresh Produce',
    image: 'https://images.unsplash.com/photo-1663753489332-626c2786e1a0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjB2ZWdldGFibGVzJTIwbWFya2V0JTIwY29sb3JmdWwlMjBmcmVzaCUyMHByb2R1Y2UlMjBkaXNwbGF5fGVufDB8fHx8MTc3NDU5ODkxMXww&ixlib=rb-4.1.0&q=85',
    link: '/organic-hues'
  },
  {
    id: 'millets-grains',
    name: 'Millets & Grains',
    image: 'https://images.unsplash.com/photo-1740501813766-067394db5b64?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHw0fHxJbmRpYW4lMjBzcGljZXMlMjB0dXJtZXJpYyUyMG9yZ2FuaWMlMjB0cmFkaXRpb25hbCUyMGJvd2xzfGVufDB8fHx8MTc3NDU5ODkwM3ww&ixlib=rb-4.1.0&q=85',
    link: '/organic-hues'
  },
  {
    id: 'ready-meals',
    name: 'Ready Meals',
    image: 'https://images.pexels.com/photos/5775684/pexels-photo-5775684.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
    link: '/organic-hues'
  },
  {
    id: 'healthy-snacks',
    name: 'Healthy Snacks',
    image: 'https://images.unsplash.com/photo-1694958123664-4c8414e6b8a1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwyfHxJbmRpYW4lMjBzcGljZXMlMjB0dXJtZXJpYyUyMG9yZ2FuaWMlMjB0cmFkaXRpb25hbCUyMGJvd2xzfGVufDB8fHx8MTc3NDU5ODkwM3ww&ixlib=rb-4.1.0&q=85',
    link: '/organic-hues'
  }
];

export const products = [
  {
    id: 1,
    name: 'Organic Cold-Pressed Coconut Oil',
    category: 'Oils',
    price: 450,
    image: 'https://images.unsplash.com/photo-1728910758653-7e990e489cac',
    brand: 'organic-hues',
    description: 'Pure, chemical-free coconut oil extracted using traditional methods'
  },
  {
    id: 2,
    name: 'Millet Mix Powder',
    category: 'Powders',
    price: 280,
    image: 'https://images.unsplash.com/photo-1656497119922-068c6a5e1193',
    brand: 'organic-hues',
    description: 'Nutritious blend of 5 ancient millets for everyday health'
  },
  {
    id: 4,
    name: 'Traditional Spice Box Set',
    category: 'Spices',
    price: 650,
    image: 'https://images.unsplash.com/photo-1716816211590-c15a328a5ff0',
    brand: 'organic-hues',
    description: '7 essential Indian spices in premium packaging'
  }
];